import React from 'react'
import { CFooter } from '@coreui/react-pro'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <a href="https://www.bestera.com.tr/rutist" target="_blank" rel="noopener noreferrer">
          Rutist
        </a>
        <span className="ms-1">&copy; 2022 - {new Date().getFullYear()} bestERA.</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        <a href="https://www.bestera.com.tr" target="_blank" rel="noopener noreferrer">
          bestERA
        </a>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
